import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { PhoneInput } from 'react-international-phone';
import 'react-international-phone/style.css';
import "./PhoneInput.scss";

import { MaskedValue } from "@repo/design-system/components/ui";

const getDisplayValue = (val) => {
  if (val === undefined || val === null || val === '') return '+91';
  const valStr = String(val);
  if (valStr.startsWith('+')) return valStr;
  return '+91' + valStr;
};

const getRawPhoneNumber = (phone, country) => {
  const dialCode = country?.dialCode || '91';
  const digits = phone.replace(/\D/g, '');
  if (digits.startsWith(dialCode)) {
    return digits.slice(dialCode.length);
  }
  return digits;
};

const Phone = ({
  defaultCountry = 'in',
  value,
  name,
  onBlur,
  onChange,
  isDisable = false,
  isReadOnly = false,
  placeholder,
  isMasked = false,
  maskedType = ""
}) => {

  const [hasChanged, setHasChanged] = useState(false);
  const [editorData, setEditorData] = useState(getDisplayValue(value));

  useEffect(() => {
    if (value === undefined || value === null || value === '') {
      if (editorData !== '+91') {
        setEditorData('+91');
      }
      return;
    }

    const currentDigits = editorData.replace(/\D/g, '');
    const incomingDigits = String(value).replace(/\D/g, '');

    if (currentDigits.endsWith(incomingDigits) && currentDigits.length - incomingDigits.length <= 4) {
      return;
    }

    setEditorData(getDisplayValue(value));
  }, [value]);

  const handleInputChange = (phone, meta) => {

    if (!hasChanged) {
      setHasChanged(true);
      return;
    }
    if (onChange) {
      const rawPhone = getRawPhoneNumber(phone, meta?.country);
      if (phone !== editorData) {
        setEditorData(phone);
        onChange(rawPhone);
      }
    }
  };

  // if (isMasked) {
  //   return (
  //     <MaskedValue value={value}
  //       maskedType={maskedType}
  //       targetId={name} />
  //   )
  // }

  return (
    <div className="phone-input-component">
      <PhoneInput defaultCountry={defaultCountry}
        value={editorData} onBlur={onBlur}
        onChange={handleInputChange} disabled={isDisable}
        placeholder={placeholder} readOnly={isReadOnly} />
    </div>
  );
};

Phone.propTypes = {
  defaultCountry: PropTypes.string,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  isDisable: PropTypes.bool,
  isReadOnly: PropTypes.bool,
  placeholder: PropTypes.string,
  inputInfoConfig: PropTypes.shape({
    isInfoIcon: PropTypes.bool,
    iconName: PropTypes.string,
    message: PropTypes.string,
  }),
};

export default Phone;